module.exports = __webpack_public_path__ + "img/join-us-7.8940db22.png";